import TextContent from "../cardContents/TextContent";
import AudioContent from "../cardContents/AudioContent";
import AudioTextContent from "../cardContents/AudioTextContent";
import ImageContent from "../cardContents/ImageContent";
import ImageTextContent from "../cardContents/ImageTextContent";
import { CARD_TYPES } from "../../utils/consts";

const dicto = {
  [CARD_TYPES.TEXT]: TextContent,
  [CARD_TYPES.AUDIO]: AudioContent,
  [CARD_TYPES.IMAGE]: ImageContent,
  [CARD_TYPES.AUDIOTEXT]: AudioTextContent,
  [CARD_TYPES.IMAGETEXT]: ImageTextContent,
};

export default function ContentSelector(props) {
  const { data } = props;

  const Elem = dicto[data.type];

  if (!Elem) {
    return <>ERROR: NO SUITABLE CONTENT</>;
  }

  return <Elem data={data} />;
}
